<template>
    <div>
        <ValidationObserver ref="formModalValidate">
                <b-row>
                    <div class="col-12">
                        <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('name')">
                                <b-form-input :validate-error="errors[0]" v-model="form.name">
                                </b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="code" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('city_code')">
                                <b-form-input :validate-error="errors[0]" v-model="form.city_code">
                                </b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="state_id" rules="required" v-slot="{ valid, errors }">
                            <b-form-group :label="$t('state')">
                                <state-selectbox v-model="form.state_id"></state-selectbox>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                </b-row>
            </ValidationObserver>
            <div class="col-12 mt-3 d-flex">
                <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                    {{ $t("save").toUpperCase() }}
                </b-button>
            </div>
    </div>
</template>

<script>
    //Component
    import StateSelectbox from "@/components/interactive-fields/StateSelectbox";
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import CityService from "@/services/CityService";

    export default {
        components: {
            ValidationProvider, ValidationObserver,
            StateSelectbox
        },
        data() {
            return {
                formLoading: false,
                form: {
                    state_id: null,
                    city_code: null,
                    name: null,
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    CityService.store(this.form)
                                   .then((response) => {
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("createFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   });
                }
            }
        }
    }
</script>
